import type { FaireProductEntity } from "../../entity_types/product";

export const p_bjvse7muba: FaireProductEntity = {
  token: "p_bjvse7muba",
  type: "product",
  name: "Ice Cream Drip Printed Mesh Trucker Hat",
  brandToken: "b_6vj74fwatr",
  brandName: "Flying S Company",
  imageUrl:
    "https://cdn.faire.com/fastly/931781674aa8578e606a2c4f4b91a4b62323bd11f7440434ad22c14f9c88cc57.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bef2bf586f5c615dc6c037da87d09760f3c1a8212144fadfce8b148df767d2cb.jpeg",
    "https://cdn.faire.com/fastly/8107dab887b50cf18d83269a4e844f8fa35d7f515c1b3c682901d755761f839b.jpeg",
    "https://cdn.faire.com/fastly/74b98aed3fd6f173c63c9de0d168c125c379826858f7f0cef64d5a32004ab89f.jpeg",
    "https://cdn.faire.com/fastly/15951794f921a099674df1e2e34ce12b4d8188afd15121d68a4cfa3e16baf9c1.jpeg",
    "https://cdn.faire.com/fastly/6dc0248ae3474d9dad0b30ee5eab215584c5eff53ce709b39c34a199c7a06558.jpeg",
    "https://cdn.faire.com/fastly/865fe8c23d90484b1d0d1745e1f3e71065d81bf5247537e048b58e3d590b7508.jpeg",
  ],
  priceDollars: 8.49,
  description:
    "The drip is unmatched. Hands down, your kid will think you're cool. The most perfect add on to all your sport outfits. Add a playful pop to your summer style with our Ice Cream Drip Foam Trucker Hat. Featuring a mint foam front panel, a dripping ice cream bill, and a colorful sprinkles underbill, this hat is a treat for any outfit. The waffle cone printed mesh back adds a trendy shimmer while keeping you cool and comfortable.\nPerfect for ball games, summer festivals, or just making a fun fashion statement, this adjustable snapback cap blends whimsical design with the comfort of a classic trucker hat.\nDetails:\nMint foam front panel with pink ice cream drip brim\n\nColorful sprinkle print for a fun, unique look\n\nWaffle cone printed mesh back for breathability\n\nAdjustable snapback closure for a custom fit\n\nLightweight and comfortable for all-day wear\n\nThese caps are a 5 panel seamless foam front with cotton lining behind foam and cotton sweatband to help you stay cool! These have a high crownheight of 4in and snap closure.\nOSFM. Supports adult hat sizes 6 - 7 1/2 or circumference measurements of 20in - 23 1/2in.\nYouth hats size circumference measures approximately of 17.5-20.5in with a 3in crown.\nOrder today! Please do not use images without permission, all designs are copyright of Flying S Company.",
  tags: [],
  msrpDollars: 16.99,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:06.632Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
